import script from "./tableCom.vue?vue&type=script&setup=true&lang=js"
export * from "./tableCom.vue?vue&type=script&setup=true&lang=js"

import "./tableCom.vue?vue&type=style&index=0&id=71e7e72e&lang=less&scoped=true"

import exportComponent from "../../../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.2.13_webpack@5.101.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71e7e72e"]])

export default __exports__